import { render, staticRenderFns } from "./CustomDutiesQuoteSection.vue?vue&type=template&id=95a0782c&scoped=true&"
import script from "./CustomDutiesQuoteSection.vue?vue&type=script&lang=ts&"
export * from "./CustomDutiesQuoteSection.vue?vue&type=script&lang=ts&"
import style0 from "./CustomDutiesQuoteSection.vue?vue&type=style&index=0&id=95a0782c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95a0782c",
  null
  
)

export default component.exports